module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Chat-error-7fa9ea806eb030f82383e9a96cbc9b14.svg";